import { render, staticRenderFns } from "./componente_upFoto.vue?vue&type=template&id=235601c4&"
import script from "./componente_upFoto.vue?vue&type=script&lang=js&"
export * from "./componente_upFoto.vue?vue&type=script&lang=js&"
import style0 from "./componente_upFoto.vue?vue&type=style&index=0&id=235601c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports